import {db} from '@src/services/db'
import {useObservable} from "@vueuse/rxjs";
import {liveQuery} from "dexie";
import VCard from "@src/types/VCard";


export function useVCards() {
    function getVcardContactById(id: number) {
        return useObservable<VCard | undefined>(
            // @ts-ignore
            liveQuery(async () => {
                const card = await db.vcards
                    .where('id')
                    .equals(id)
                    .first();
                return card
            }),
            {
                initialValue: undefined
            }
        )
    }

    function getVCards() {
        return useObservable<VCard[]>(
            // @ts-ignore
            liveQuery(async () => {
                const vcards = await db.vcards.toArray()

                return vcards
            }),
            {
                initialValue: []
            }
        )
    }

    return {
        getVcardContactById,
        getVCards
    }
}
